import * as React from 'react';

const SvgIconSortNumberAscending = ({
  color = '#40180B',
  ...props
}: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 1.79292V3.00002V8.50002H19H19.5V9.50002H19H17H15H14.5V8.50002H15H16.5V4.20713L15.3536 5.35358L15 5.70713L14.2929 5.00002L14.6464 4.64647L16.6464 2.64647L17.5 1.79292ZM7.5 5.50002V6.00002V16.7929L9.64645 14.6465L10 14.2929L10.7071 15L10.3536 15.3536L7.35355 18.3536L7 18.7071L6.64645 18.3536L3.64645 15.3536L3.29289 15L4 14.2929L4.35355 14.6465L6.5 16.7929V6.00002V5.50002H7.5ZM15 12.5H14.5V13V16V16.5H15H18.5V18.5H15H14.5V19.5H15H19H19.5V19V16V13V12.5H19H15ZM18.5 13.5V15.5H15.5V13.5H18.5Z"
      fill={color}
    />
  </svg>
);

export default SvgIconSortNumberAscending;
